if (!customElements.get("switch-column")) {
  customElements.define(
    "switch-column",
    class SwitchColumn extends HTMLElement {
      static MOBILE_WIDTH_BREAKPOINT = 900;

      connectedCallback() {
        this.initialize();
      }

      initialize() {
        this.buttons = Array.from(this.querySelectorAll("[data-view-cols]"));
        this.loader = this.querySelector(".loading-overlay");
        this.collectionGrid = document.querySelector(".collection__grid");
        this.checkInput = document.querySelector(
          ".collection__mobile-layout-checkbox",
        );
        this.sortCustomSelect = document.querySelector(
          '[data-reference-id="SortBy"]',
        );

        this.boundSetFromButton = this.setFromButton.bind(this);
        this.boundHandleResize = this.handleResize.bind(this);
        this.boundHandleLoad = this.handleLoad.bind(this);

        this.addEventListeners();
        this.handleLoad();
      }

      addEventListeners() {
        window.addEventListener("load", this.boundHandleLoad);
        window.addEventListener("resize", this.boundHandleResize);
        this.sortCustomSelect?.addEventListener(
          "wtSelectChange",
          this.boundHandleLoad,
        );
        this.buttons.forEach((button) => {
          button.addEventListener("click", this.boundSetFromButton);
        });
      }

      removeEventListeners() {
        window.removeEventListener("load", this.boundHandleLoad);
        window.removeEventListener("resize", this.boundHandleResize);
        this.sortCustomSelect?.removeEventListener(
          "wtSelectChange",
          this.boundHandleLoad,
        );
        this.buttons.forEach((button) => {
          button.removeEventListener("click", this.boundSetFromButton);
        });
      }

      handleLoad() {
        this.loader?.classList.add("loading-overlay--hidden");
        this.classList.remove("switch-column--hidden");
        if (window.innerWidth < SwitchColumn.MOBILE_WIDTH_BREAKPOINT) {
          this.setNumberOfColumns();
        } else {
          this.clearMobileColumns();
        }
      }

      handleResize() {
        if (window.innerWidth >= SwitchColumn.MOBILE_WIDTH_BREAKPOINT) {
          this.clearMobileColumns();
        } else {
          this.loader?.classList.add("loading-overlay--hidden");
          this.classList.remove("switch-column--hidden");
          this.setNumberOfColumns();
        }
      }

      getNumberOfColumns() {
        return this.dataset.col || "1";
      }

      clearMobileColumns() {
        if (!this.collectionGrid) return;
        this.collectionGrid.style.removeProperty("--cols");
        this.collectionGrid.removeAttribute("data-view");
      }

      setNumberOfColumns() {
        const colsNumber = this.getNumberOfColumns();
        if (!["1", "2"].includes(colsNumber) || !this.collectionGrid) return;

        this.collectionGrid.style.setProperty("--cols", colsNumber);
        this.collectionGrid.setAttribute("data-view", colsNumber);
        if (this.checkInput) {
          this.checkInput.checked = colsNumber === "2";
        }
        this.syncButtons(colsNumber);
      }

      setFromButton(event) {
        const button = event.currentTarget;
        const newValue = button.getAttribute("data-view-cols");
        if (!["1", "2"].includes(newValue) || !this.collectionGrid) return;

        this.collectionGrid.style.setProperty("--cols", newValue);
        this.collectionGrid.setAttribute("data-view", newValue);
        this.dataset.col = newValue;
        if (this.checkInput) {
          this.checkInput.checked = newValue === "2";
        }
        this.syncButtons(newValue);
      }

      syncButtons(colsNumber) {
        this.buttons.forEach((button) => {
          const isActive = button.getAttribute("data-view-cols") === colsNumber;
          button.classList.toggle("is-active", isActive);
          button.setAttribute("aria-pressed", isActive ? "true" : "false");
        });
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }
    },
  );
}
